import "./Projects.css";
import { Container, Grid, Link } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";

const project = {
  backgroundColor: "#111a28",
  color: "#fff",
  paddingTop: "5%",
};

const Projects = () => {
  const [portfolios, setPortfolio] = useState([]);
  const [react, setReact] = useState([]);
  const [mern, setMern] = useState([]);
  const [grupProject, setGrupProject] = useState([]);

  // https://node-api-vq70.onrender.com

  useEffect(() => {
    fetch("portfolio.json")
      .then((res) => res.json())
      .then((data) => setPortfolio(data));
  }, []);

  useEffect(() => {
    fetch("portfolio.json")
      .then((res) => res.json())
      .then((data) => setReact(data));
  }, []);

  useEffect(() => {
    fetch("portfolio.json")
      .then((res) => res.json())
      .then((data) => setMern(data));
  }, []);

  useEffect(() => {
    fetch("grup.json")
      .then((res) => res.json())
      .then((data) => setGrupProject(data));
  }, []);

  return (
    <Container sx={{ flexGrow: 1 }} id="project" style={project}>
      <h1 className="pseudo">My Projects</h1>

      <Box className="project-button">
        <Box
          className="nav nav-pills me-3 pb-5"
          id="v-pills-tab"
          role="tablist"
          aria-orientation="vertical"
        >
          <button
            className="nav-link active"
            id="v-pills-home-tab"
            data-bs-toggle="pill"
            data-bs-target="#v-pills-home"
            type="button"
            role="tab"
            aria-controls="v-pills-home"
            aria-selected="true"
          >
            All
          </button>
          <button
            className="nav-link"
            id="v-pills-profile-tab"
            data-bs-toggle="pill"
            data-bs-target="#v-pills-profile"
            type="button"
            role="tab"
            aria-controls="v-pills-profile"
            aria-selected="false"
          >
            REACT JS
          </button>
          <button
            className="nav-link"
            id="v-pills-messages-tab"
            data-bs-toggle="pill"
            data-bs-target="#v-pills-messages"
            type="button"
            role="tab"
            aria-controls="v-pills-messages"
            aria-selected="false"
          >
            MERN
          </button>
          <button
            className="nav-link"
            id="v-pills-settings-tab"
            data-bs-toggle="pill"
            data-bs-target="#v-pills-settings"
            type="button"
            role="tab"
            aria-controls="v-pills-settings"
            aria-selected="false"
          >
            GRUP PROJECT
          </button>
        </Box>

        <Box className="tab-content" id="v-pills-tabContent">
          <Box
            className="tab-pane fade show active"
            id="v-pills-home"
            role="tabpanel"
            aria-labelledby="v-pills-home-tab"
          >
            <Box sx={{ flexGrow: 1 }}>
              <Grid
                container
                spacing={{ xs: 2, md: 3 }}
                columns={{ xs: 4, sm: 8, md: 12 }}
              >
                {portfolios.map((portfolio) => (
                  <Grid key={portfolio._id} item xs={4} sm={4} md={4}>
                    <Link
                      className="text-decoration-none"
                      rel="noreferrer"
                      target="_blank"
                      href={portfolio.link}
                    >
                      <Box className="box">
                        <img
                          className="services-img"
                          src={portfolio.img}
                          alt="images"
                        />
                        <Box className="card-body">
                          <h2 className="services-title">{portfolio.name}</h2>
                          <h2 className="services-title">
                            {portfolio.description}
                          </h2>
                        </Box>
                      </Box>
                    </Link>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Box>

          <div
            className="tab-pane fade"
            id="v-pills-profile"
            role="tabpanel"
            aria-labelledby="v-pills-profile-tab"
          >
            <Box sx={{ flexGrow: 1 }}>
              <Grid
                container
                spacing={{ xs: 2, md: 3 }}
                columns={{ xs: 4, sm: 8, md: 12 }}
              >
                {react.map((rt) => (
                  <Grid key={rt._id} item xs={4} sm={4} md={4}>
                    <a
                      className="text-decoration-none"
                      rel="noreferrer"
                      target="_blank"
                      href={rt.link}
                    >
                      <div className="box">
                        <img
                          className="services-img"
                          src={rt.img}
                          alt="images"
                        />
                        <div className="card-body">
                          <h2 className="services-title">{rt.name}</h2>
                          <h2 className="services-title">{rt.description}</h2>
                        </div>
                      </div>
                    </a>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </div>

          <div
            className="tab-pane fade"
            id="v-pills-messages"
            role="tabpanel"
            aria-labelledby="v-pills-messages-tab"
          >
            <Box sx={{ flexGrow: 1 }}>
              <Grid
                container
                spacing={{ xs: 2, md: 3 }}
                columns={{ xs: 4, sm: 8, md: 12 }}
              >
                {mern.map((mr) => (
                  <Grid key={mr._id} item xs={4} sm={4} md={4}>
                    <a
                      className="text-decoration-none"
                      rel="noreferrer"
                      target="_blank"
                      href={mr.link}
                    >
                      <div className="box">
                        <img
                          className="services-img"
                          src={mr.img}
                          alt="images"
                        />
                        <div className="card-body">
                          <h2 className="services-title">{mr.name}</h2>
                          <h2 className="services-title">{mr.description}</h2>
                        </div>
                      </div>
                    </a>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </div>

          <div
            className="tab-pane fade"
            id="v-pills-settings"
            role="tabpanel"
            aria-labelledby="v-pills-settings-tab"
          >
            <Box sx={{ flexGrow: 1 }}>
              <Grid
                container
                spacing={{ xs: 2, md: 3 }}
                columns={{ xs: 4, sm: 8, md: 12 }}
              >
                {grupProject.map((gp) => (
                  <Grid key={gp._id} item xs={4} sm={4} md={4}>
                    <a
                      className="text-decoration-none"
                      rel="noreferrer"
                      target="_blank"
                      href={gp.link}
                    >
                      <div className="box">
                        <img
                          className="services-img"
                          src={gp.img}
                          alt="images"
                        />
                        <div className="card-body">
                          <h2 className="services-title">{gp.name}</h2>
                          <h2 className="services-title">{gp.description}</h2>
                        </div>
                      </div>
                    </a>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </div>
        </Box>
      </Box>
    </Container>
  );
};

export default Projects;
